export enum PersonalizationStatus {
    OWNER = 'OWNER',
    OTHER = 'OTHER',
    NONE = 'NONE'
}
